import * as actions from './itemCategory/actions'
import * as mutations from './itemCategory/mutations'
import * as getters from './itemCategory/getters'

import { dataProps } from './itemCategory/properties'

const state = {
    list: [],
    fabric_list: [],
    all_list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    item_type: 0//tailoring product, fabric, ready to wear, raw material, asset
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/itemCategory.js